import React from "react";
import { useParams } from "react-router-dom";
import SiteTerminologyContent from "pages/Clients/Sites/SiteApplication/SiteTerminology/SiteTerminologyContent";

const noop = () => {};

// Client-wide terminology editor, per locale. Shared across all of the client's
// sites: it layers on top of the Application template and is itself overridable
// per site app. Reuses the Site Terminology screen scoped to the client.
const ClientTerminology = () => {
	const { id } = useParams();

	return (
		<SiteTerminologyContent
			state={{ isReadOnly: false }}
			dispatch={noop}
			scope={{ level: "client", id: Number(id) }}
		/>
	);
};

export default ClientTerminology;
